import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import CustomInputField from './common/CustomInputField';
import ActionButton from './common/Action Buttons/ActionButton';
import ActionButton2 from './common/Action Buttons/ActionButton2';
import CustomDatePicker from './common/CustomDatePicker';
import CustomSelection from './common/CustomSelection';

const Wrapper = styled.div`
    min-width: 593px;
    display: flex;
    flex-direction: column;
  
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

const RepresentativeInfo = styled.div`
    padding: 44px 40px;
`;

const RepresentativeHeading = styled.div`
    font-size: 20px;
    margin-bottom: 40px;
    /* identical to box height, or 100% */
    
    /* default/gray/700 */
    color: #4A5568;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
  align-items: center;
  
  > * {
     margin-right: 20px;
  }
`;

const ActionsWrapper = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    height: fit-content;
    
    margin-bottom: 40px;
    
    display: flex;
    flex-direction: row;
    justify-content: start;
    
     > * {
      margin-right: 24px;
    }
    
    padding: 0 40px;
`;


const styles = {inputFieldMargin: {margin: '0 20px 20px 0'}};


const genderData = [
    {
        id: 1,
        type: 'Male'
    },
    {
        id: 2,
        type: 'Female'
    },
    {
        id: 3,
        type: 'Unspecified'
    }
];


function RepresentativeInfoSidePanel({representativeData = {}, onCancel, onSave}) {
    const [representative, setRepresentative] = useState(representativeData);

    const handleOnFieldChange = e => {
        if (!e) return;

        const {value, name} = e.target;

        setRepresentative({
            ...representative,
            [name]: value
        });
    };

    const handleOnCheckboxClick = e => {
        const {checked, name} = e.target;
        setRepresentative({
            ...representative,
            [name]: checked
        });
    };

    const handleOnSaveClick = () => {
        onSave(representative);
    };

    const handleOnDateChange = date => {
        setRepresentative({
            ...representative,
            dateOfBirth: date
        });
    };

    const handleOnGenderChange = e => {
        const {value} = e.target;
        setRepresentative({
            ...representative,
            genderId: value
        });
    };

    return (
        <Wrapper>

            <RepresentativeInfo>


                <Row>
                    <CustomInputField
                        label="First Name"
                        onChange={handleOnFieldChange}
                        value={representative.firstName}
                        placeholder=""
                        name="firstName"
                    />

                    <CustomInputField
                        label="Middle Name"
                        onChange={handleOnFieldChange}
                        value={representative.middleName}
                        placeholder=""
                        name="middleName"
                    />

                    <CustomInputField
                        label="Last Name"
                        onChange={handleOnFieldChange}
                        value={representative.lastName}
                        placeholder=""
                        name="lastName"
                    />
                </Row>

                <Row>
                    <CustomDatePicker
                        label="Date of Birth"
                        onDateChange={handleOnDateChange}
                        date={representative.dateOfBirth}
                    />

                    <CustomSelection
                        label="Gender"
                        onChange={handleOnGenderChange}
                        value={representative.genderId}
                        name="genderId"
                        placeholder=""
                    >
                        {
                            genderData.map(gender => <MenuItem key={gender.id} name="genderId" value={gender.id}>{gender.type}</MenuItem>)
                        }
                    </CustomSelection>
                </Row>

                <Row>
                    <CustomInputField
                        label="Nationality"
                        onChange={handleOnFieldChange}
                        value={representative.nationality}
                        placeholder=""
                        name="nationality"
                    />

                    <CustomInputField
                        label="TRN"
                        onChange={handleOnFieldChange}
                        value={representative.trn}
                        placeholder=""
                        name="trn"
                        mask="999 999 999"
                    />
                </Row>


                <Row>
                    <CustomInputField
                        label="Email"
                        onChange={handleOnFieldChange}
                        value={representative.email}
                        placeholder=""
                        name="email"
                    />

                    <CustomInputField
                        label="Contact Number"
                        onChange={handleOnFieldChange}
                        value={representative.contactNumber}
                        placeholder=""
                        name="contactNumber"
                        mask="+1 (999) 999 9999"
                    />
                </Row>

                <Row>
                    Set as Primary Representative
                    <Checkbox
                        checked={representative.primary}
                        onChange={handleOnCheckboxClick}
                        value={true}
                        style={{marginLeft: '10px'}}
                        color="primary"
                        name="primary"
                    />
                </Row>
            </RepresentativeInfo>

            <ActionsWrapper>
                <ActionButton onClick={handleOnSaveClick}>Save</ActionButton>
                <ActionButton2 onClick={onCancel}>Cancel</ActionButton2>
            </ActionsWrapper>
        </Wrapper>
    );
}

RepresentativeInfoSidePanel.propTypes = {};
RepresentativeInfoSidePanel.defaultProps = {};

export default RepresentativeInfoSidePanel;
